export default "/static/webpack/images/home/logos/pactclothing.png";